export const TOKENS_STORAGE_KEY = 'nsportal_client_tokens';
export const PORTAL_AXIOS_TIMEOUT = 10000; // 10 segundos
export const MFE_AXIOS_TIMEOUT = 30000; // 30 segundos

export const SESSION_URL = `${import.meta.env.VITE_FOUNDATION_API}/keystone/Authentication/session`;
export const EXCHANGE_URL = `${import.meta.env.VITE_FOUNDATION_API}/keystone/Authentication/exchange`;

export let isAutoLogoutInProgress = false;

export const setAutoLogoutInProgress = (value: boolean) => {
  isAutoLogoutInProgress = value;
};
